import { render, staticRenderFns } from "./UpdateCustomerType.vue?vue&type=template&id=6999ade0&scoped=true"
import script from "./UpdateCustomerType.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerType.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerType.vue?vue&type=style&index=0&id=6999ade0&prod&scoped=true&lang=css"
import style1 from "./UpdateCustomerType.vue?vue&type=style&index=1&id=6999ade0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999ade0",
  null
  
)

export default component.exports